export function addSearch(search) {
  return {
    type: "ADD_SEARCH",
    search
  };
}
